import { useParams, Navigate } from "react-router-dom";
import { IndustryPage } from "../components/IndustryPage";
import { getIndustryBySlug } from "../lib/industries";

export default function IndustryDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const industry = slug ? getIndustryBySlug(slug) : undefined;

  if (!industry) {
    return <Navigate to="/industries" replace />;
  }

  return <IndustryPage industry={industry} />;
}
